
import React  from "react";

interface ModalProps {
    title: string;
    children: React.ReactNode;
    footer?: React.ReactNode;
    onClose: () => void;
    show: boolean;
}

const Modal:React.FC<ModalProps> = ({title, children, footer, show, onClose}) => {

    if (!show) {
        return null;
    }

    return (
    <div className="xan-modal modal-open">
        <div className="modal-backdrop fade show" onClick={() =>  onClose()}></div>
        <div
            className="modal fade show"
            id="exampleModal"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            {title}
                        </h5>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={() =>onClose()}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {children}
                    </div>
                    {footer && ( <div className="modal-footer">
                        {footer}
                    </div>)}
                </div>
            </div>
        </div>
    </div>
    );
}

export default Modal;